import React from 'react'
import EKDonutChart from '../../Charts/EKDonutChart'
import AddEquity from './AddEquity'
import EditEquity from './EditEquity'

function UserEquity() {
    return (
        <React.Fragment>
            <div className="card card-body mt-3">
                <AddEquity />
            </div>

            <div className="card card-body mt-3">
            <h2>Oversikt egenkapital</h2>
            <EditEquity />
            </div>

            <div className="card card-body mt-3">
                <EKDonutChart />
            </div>

        </React.Fragment>

    )
}
export default UserEquity